import { isEmpty } from 'lodash';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

/**
 *
 * @param {Object} params
 * @param {string} actionType
 * @return {function(*)}
 * @private
 */
export const searchForParticipants = params => {
    if (isEmpty(params)) {
        throw new Error('Error in searchForParticipants. Must provide query parameters');
    }
    const baseUrl = `${params.pathsContext.adminServerUrl}/participants/search`;
    if (!params.pageNumber) {
        params.pageNumber = 1;
    }
    if (!params.pageSize) {
        params.pageSize = 50;
    }
    delete params.pathsContext;
    const url = buildQueryString(params, baseUrl);
    try {
        return VerbFetch(url);
    } catch {
        return null;
    }
};
